var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.historyRecord)?_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"is-flex flex-direction--column padding-left--small"},[_c('span',{staticClass:"is-flex"},[_vm._v("\n            "+_vm._s(new Intl.DateTimeFormat('en', {
                year:'numeric',
                month:'2-digit',
                day:'2-digit',
              })
              .format(new Date(_vm.historyRecord.lastUpdateDate)))+"\n          ")])])]),(_vm.fieldEnabled('FIRST_NAME')
          || _vm.fieldEnabled('LAST_NAME'))?_c('td',[_c('div',[_vm._v("\n        "+_vm._s(_vm.personHistoryDisplayName)+"\n      ")])]):_vm._e(),_c('td',{staticStyle:{"text-align":"right !important"}},[_c('router-link',{attrs:{"to":{
          name: 'PidHistoryRecordDetails',
          query: {
            recordId: _vm.historyRecord.lastTranSerialNumber,
            retired: _vm.isRetired,
          }
        }}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'angle-double-right'],"size":"2x","title":"View Details"}})],1)],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }